module.exports = __webpack_public_path__ + "img/ftth_index05_n.475e4476.png";